import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext } from '@tanstack/react-router'
import type { LDClient } from 'launchdarkly-react-client-sdk'

interface RouterContext {
	queryClient: QueryClient
	ldClient: LDClient | undefined
}

export const Route = createRootRouteWithContext<RouterContext>()()
